import { store } from '../../../store'
import { MessageDataType } from '../types'
import { updateBalancesAction } from '../../../store/account/actions'
import { e2w } from '../../../utils/number'

export interface WsAccountChangedWsData {
  type: 'account_changed'
  data: {
    accountId: number
    available: number
    createdAt: number
    currencyId: number
    sequenceId: number
    spotsFrozen: number
    total: number
    userId: number
  }
  userId: number
}

export function onMessageAccountChanged(data: MessageDataType) {
  switch (data.type) {
    // Receive user balance changed data
    case 'account_changed':
      updateAccountChanged(data as WsAccountChangedWsData)
      break
  }
}

function updateAccountChanged(data: WsAccountChangedWsData) {
  const accountInfo = store.getState().account.accountInfo
  if (!accountInfo) return
  const { userId } = accountInfo
  if (Number(userId) === Number(data.userId)) {
    store.dispatch(
      updateBalancesAction({
        currencyId: data.data.currencyId,
        available: e2w(data.data.available).toString(),
        freeze: e2w(data.data.spotsFrozen).toString(),
      })
    )
  }
}
